import React from 'react';

class MainPage extends React.Component {
  render() {
    return <div>MainPage</div>;
  }
}

export default MainPage;
